module.exports = __webpack_public_path__ + "static/img/becareful.141fe53.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/becareful.png
// module id = boO1
// module chunks = 1